import { isEmpty } from 'lodash-es';
import { getInteractionForCandidateIdAndJobId } from 'wisestep-api';

export const layoutTabNames = [
  {
    tabName: 'Profile',
  },
  {
    tabName: 'Mappings',
  },
  {
    tabName: 'Submissions',
  },
  {
    tabName: `CV's & Documents`,
  },
  {
    tabName: 'Communication Logs',
  },
];

export const layoutTabNamesCrucible = [
  {
    tabName: 'Profile',
  },
  {
    tabName: 'Mappings',
  },
  {
    tabName: 'Submissions',
  },
  {
    tabName: `CV's & Documents`,
  },
  {
    tabName: 'Communication Logs',
  },
  {
    tabName: 'Activity Logs',
  },
];
export const cvTabs = [
  {
    tabName: 'CV',
  },
  {
    tabName: 'Other Documents',
  },
];

export const submissionLayoutTabNamesForCrucible = (count: number) => [
  {
    tabName: 'TimeLines',
  },
  {
    tabName: 'Submission Details',
  },
  {
    tabName: `Recruiter questions ${count}`,
  },
  {
    tabName: 'Events',
  },
  {
    tabName: `Communications`,
  },
  {
    tabName: 'Candidate Review',
  },
  {
    tabName: 'CV',
  },
];

export const submissionLayoutTabNames = [
  {
    tabName: 'TimeLines',
  },
  {
    tabName: 'Submission Details',
  },
  {
    tabName: 'Events',
  },
  {
    tabName: `Information Request`,
  },
  {
    tabName: 'Candidate Review',
  },
  {
    tabName: 'CV',
  },
  {
    tabName: 'Document',
  },
  {
    tabName: 'Potential Revenue',
  },
];

export const submissionLayoutTabNamesWithoutPotentialRevenueTab = [
  {
    tabName: 'TimeLines',
  },
  {
    tabName: 'Submission Details',
  },
  {
    tabName: 'Events',
  },
  {
    tabName: `Information Request`,
  },
  {
    tabName: 'Candidate Review',
  },
  {
    tabName: 'CV',
  },
  {
    tabName: 'Document',
  },
];

export const mappingTabNames = [
  {
    tabName: 'TimeLines',
  },
  {
    tabName: 'Information Request',
  },
];

export type RouteOptions =
  | 'mappings'
  | 'submissions'
  | 'documents'
  | 'communication-logs'
  | 'profile'
  | 'activity-logs';
export const routeNames: RouteOptions[] = [
  'profile',
  'mappings',
  'submissions',
  'documents',
  'communication-logs',
  'activity-logs',
];
export const mapToActivityLogs = (responseList, type) =>
  responseList.map((item) => {
    return {
      id: item.id,
      activityId: item.candidateInteractionResult,
      recruiterId: item.recruiterId,
      recruiterName: item.recruiterName,
      modifiedRecruiterName: item.modifiedRecruiterName,
      jobId: item.jobId,
      jobCode: item.jobCode,
      jobTitle: item.mappedJobTitle,
      createdOn: new Date(item.createdOn),
      applicationStage: item.applicationStage,
      applicationState: item.applicationState,
      toNumber: item.phoneNumber ?? '',
      toEmail: item.email, //lastEmailAction commented email
      contactActionsObjs: item.contactActionsObjs ? item.contactActionsObjs : [],
      callDuration: item.contactActionsObjs?.length
        ? item.contactActionsObjs[0].callDuration
        : undefined,
      stage: '',
      state: '',
      activityType: type,
    };
  });

export const getActivityForCandidateIdAndJobId = async (candidateId, jobId) => {
  const responseInteractionList = await getInteractionForCandidateIdAndJobId(candidateId, jobId);
  if (!isEmpty(responseInteractionList?.data)) {
    const interactionActivitySet = responseInteractionList.data.map((response) => ({
      date: response?.date,
      activities: response?.activities.map((activity) => ({
        ...activity,
        activityType: 'INTERACTION',
      })),
    }));
    return interactionActivitySet;
  }
};

export interface OtherDocuments {
  id?: string;
  workspaceId?: string;
  resumeLocation?: string;
  resumeUploadedOn?: string;
  content?: string;
  s3FileName?: string;
  candidateId?: string;
  resumeFileName?: string;
  jobId?: string;
  source?: string;
  resumeUploadedBy?: string;
  tag?: string;
  resumeFileType?: string;
  documentLocation: string;
  originalName: string;
  uploadedOn: string;
  type?: string;
  recruiterEmail?: string;
  jobTitle?: string;
  jobCode?: string;
}

export interface ICandidateOtherDoc {
  blankResume?: boolean | null;
  candidateId?: string | null;
  content?: string | null;
  id?: string | null;
  jobId?: string | null;
  resumeFileName?: string | null;
  resumeFileOriginalName?: string | null;
  resumeFileType?: string | null;
  resumeLocation?: string | null;
  resumeUploadedBy?: string | null;
  resumeUploadedOn?: string | null;
  s3FileName?: string | null;
  source?: string | null;
  tag?: string | null;
  workspaceId?: string | null;
}
